module.exports = __webpack_public_path__ + "img/SFATA.ff2e21ec.jpeg";